import { intentOptions } from 'app.constants';
import { find } from 'es-toolkit/compat';
import type { GetOverviewTableData } from 'features/traffic/campaigns/campaign-configs/types';
import type { FeaturedBrandsOverviewTableData } from '../types';

export const getOverviewTableData: GetOverviewTableData<FeaturedBrandsOverviewTableData> = ({ common, name }) => {
  const { accessControlGroup, businessGroup, marketingType, productLine, programs, reason, programSubGroup } = common ?? {};

  const programValues = programs?.join(', ');
  const overviewTableData = {
    accessControlGroup: {
      label: 'Access Control Group',
      value: accessControlGroup,
    },
    businessGroup: {
      label: 'Business Group',
      value: businessGroup,
    },
    marketingType: {
      label: 'Marketing type',
      value: find(intentOptions, (intentOptions) => intentOptions.value === marketingType)?.display,
    },
    name: {
      label: 'Campaign name',
      value: name,
    },
    productLine: {
      label: 'Product line',
      value: productLine,
    },
    programSubGroup: {
      label: 'Program SubGroup',
      value: programSubGroup,
    },
    programs: {
      label: 'Programs',
      value: programValues,
    },
    reason: {
      label: 'Reason',
      value: reason,
    },
  };
  return overviewTableData;
};
